import React from 'react';
import {Checkbox} from 'antd';
import {WeaSearchGroup, WeaFormItem} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';

// 计划报告元素
export default class Content_plan extends React.Component {
    state = {
        eClassify: this.props.eClassify,
        ePlanStartDate: this.props.ePlanStartDate,
        ePlanEndDate: this.props.ePlanEndDate,
        ePlanDays: this.props.ePlanDays,
        eWeekly: this.props.eWeekly,
        eMonthly: this.props.eMonthly,
    };

    render() {
        const {eClassify, ePlanStartDate, ePlanEndDate, ePlanDays, eWeekly, eMonthly} = this.state;

        let EClassify = (
            <WeaFormItem label={getLabel(455, '分类')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={eClassify} onChange={e => this.setState({eClassify: e.target.checked})}/>
            </WeaFormItem>
        );

        let EPlanStartDate = (
            <WeaFormItem label={getLabel(22168, '计划开始日期')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={ePlanStartDate} onChange={e => this.setState({ePlanStartDate: e.target.checked})}/>
            </WeaFormItem>
        );

        let EPlanEndDate = (
            <WeaFormItem label={getLabel(22170, '计划结束日期')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={ePlanEndDate} onChange={e => this.setState({ePlanEndDate: e.target.checked})}/>
            </WeaFormItem>
        );

        let EPlanDays = (
            <WeaFormItem label={getLabel(33625, '计划天数')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={ePlanDays} onChange={e => this.setState({ePlanDays: e.target.checked})}/>
            </WeaFormItem>
        );

        let EWeekly = (
            <WeaFormItem label={getLabel(20619, '周报')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={eWeekly} onChange={e => this.setState({eWeekly: e.target.checked})}/>
            </WeaFormItem>
        );

        let EMonthly = (
            <WeaFormItem label={getLabel(20617, '月报')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <Checkbox size="default" checked={eMonthly} onChange={e => this.setState({eMonthly: e.target.checked})}/>
            </WeaFormItem>
        );

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    <EShowNum ref="eShowNum" value={this.props.eShowNum}/>
                    <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                    {EClassify}
                    {EPlanStartDate}
                    {EPlanEndDate}
                    {EPlanDays}
                    {EWeekly}
                    {EMonthly}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentClassify: this.state.eClassify,
            eContentPlanStartDate: this.state.ePlanStartDate,
            eContentPlanEndDate: this.state.ePlanEndDate,
            eContentPlanDays: this.state.ePlanDays,
            eContentWeekly: this.state.eWeekly,
            eContentMonthly: this.state.eMonthly
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_plan.js